import type { CascaderOption } from '../helpers';
import type { SearchResult } from '../utils/search-utils';
import { CascaderColumns } from './CascaderColumns';
import { CascaderSearchResults } from './CascaderSearchResults';

type CascaderPopoverContentProps = {
  /** 検索中かどうか */
  isSearching: boolean;
  /** 検索結果 */
  searchResults: SearchResult[];
  /** 選択済みパス（複数選択モード用） */
  selectedPaths: string[][];
  /** 複数選択モードかどうか */
  multiple: boolean;
  /** 末端ノードのみ選択可能かどうか */
  onlyLeafSelectable: boolean;
  /** 検索結果選択時のコールバック */
  onSelectSearchResult: (result: SearchResult) => void;
  /** 処理済みオプション */
  processedOptions: CascaderOption[];
  /** 現在のアクティブパス */
  activePath: string[];
  /** ホバー中のインデックス */
  hoveredIndex: number[];
  /** カラム数 */
  columnCount: number;
  /** チェックボックストグル時のコールバック */
  onCheckboxToggle: (option: CascaderOption, level: number) => void;
  /** ナビゲーション時のコールバック */
  onNavigate: (option: CascaderOption, level: number) => void;
  /** マウスエンター時のコールバック */
  onMouseEnter: (level: number, idx: number) => void;
  /** マウスリーブ時のコールバック */
  onMouseLeave: (level: number) => void;
  /** キーボードナビゲーション用のアクティブインデックス */
  activeIndex: number;
  /** フィールドのID */
  id?: string;
};

/**
 * Cascader の Popover 内コンテンツを表示するコンポーネント
 *
 * 検索結果表示または通常のカスケーダー表示を管理します。
 * 検索 Input はトリガー側に移動したため、ここにはコンテンツのみ表示。
 */
export const CascaderPopoverContent = ({
  isSearching,
  searchResults,
  selectedPaths,
  multiple,
  onlyLeafSelectable,
  onSelectSearchResult,
  processedOptions,
  activePath,
  hoveredIndex,
  columnCount,
  onCheckboxToggle,
  onNavigate,
  onMouseEnter,
  onMouseLeave,
  activeIndex,
  id,
}: CascaderPopoverContentProps) => {
  if (isSearching) {
    return (
      <CascaderSearchResults
        searchResults={searchResults}
        selectedPaths={selectedPaths}
        multiple={multiple}
        onlyLeafSelectable={onlyLeafSelectable}
        onSelectSearchResult={onSelectSearchResult}
        activeIndex={activeIndex}
        id={id}
      />
    );
  }

  return (
    <CascaderColumns
      processedOptions={processedOptions}
      activePath={activePath}
      selectedPaths={selectedPaths}
      hoveredIndex={hoveredIndex}
      multiple={multiple}
      onlyLeafSelectable={onlyLeafSelectable}
      columnCount={columnCount}
      onCheckboxToggle={onCheckboxToggle}
      onNavigate={onNavigate}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};
